export const APP_NAME = 'sauna';